/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { ClipboardIcon } from '@heroicons/react/24/outline';
import { useSnackbar } from '../../providers/SnackbarContext'; // Added import for useSnackbar

import { config } from '../../config/awsExports';
import PageBanner from '../../components/utils/PageBanner';

const { env } = config;

const openUserActivity = (link) => {
  window.open(link, '_blank');
};

const LOGS = [
  {
    name: 'Auth',
    link: env.authLogs,
  },
  {
    name: 'Backend',
    link: env.backendLogs,
  },
  {
    name: 'EventBridge',
    link: env.ebLogs,
  },
];

const COGNITO = [
  {
    name: 'Permissions',
    link: env.cognito,
  },
];

const RELEASES = [
  {
    name: 'Release Documentation',
    link: env.releases,
  },
];

const JIRA = [
  {
    name: 'Roadmap',
    link: env.roadMap,
  },
  {
    name: 'Backlog',
    link: env.backlog,
  },
];

const BUSINESSDOCU = [
  {
    name: 'Portal Documentation',
    link: env.businessDocumentation,
  },
];

const sections = [
  {
    name: '📄 CONFLUENCE PAGE',
    data: BUSINESSDOCU,
  },
  {
    name: '🚗 JIRA',
    data: JIRA,
  },
  {
    name: '🏁 RELEASES',
    data: RELEASES,
  },
  {
    name: '🎯 AWS LOGS',
    data: LOGS,
  },
  {
    name: '🤪 AWS COGNITO',
    data: COGNITO,
  },
];

export default function PortalInfo() {
  const openSnackBar = useSnackbar(); // Added hook call

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      openSnackBar('Link copied to clipboard!', 'success'); // Call snackbar on success
    }).catch(err => {
      openSnackBar('Failed to copy link.', 'error'); // Optional: Show error in snackbar
      console.error('Failed to copy link: ', err);
    });
  };

  return (
    <div className="min-h-screen bg-slate-100 scrollbar scrollbar-thin scrollbar-thumb-slate-400 scrollbar-track-slate-200">
      <PageBanner title="USEFUL LINKS" />
      <div className="p-4">
        {sections.map((section, index) => (
          <div key={index} className="mb-6">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{section.name}</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider w-20">Actions</th> {/* Adjusted width for actions column */}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {section.data.map((item) => (
                    <tr key={item.name} className="hover:bg-slate-50 transition-colors duration-150">
                      <td
                        onClick={() => openUserActivity(item.link)}
                        className="px-6 py-4 whitespace-nowrap text-slate-700 cursor-pointer"
                      >
                        {item.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center"> {/* Centered content in actions cell */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent row click event
                            copyToClipboard(item.link);
                          }}
                          className="bg-slate-200 hover:bg-slate-300 text-slate-700 font-bold p-1.5 rounded text-xs inline-flex items-center" /* Updated styles for gray button and icon */
                          title="Copy link to clipboard"
                        >
                          <ClipboardIcon className="h-4 w-4" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
